import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, Toggle, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getThemeImages } from '../../../Themes';

import styles from './SettingsToggle.styles';

function SettingsToggle({ icon, title, description, isSelected, onChange, theme, images }) {
  const Images = images || getThemeImages(theme.name);

  return (
    <View testID={FrameworkTestKeys.settingsToggleContainer}>
      <View style={styles.containerStyle} testID={FrameworkTestKeys.settingsToggleContainerView}>
        <Icon
          type="image"
          name={Images[icon]}
          size={34}
          testID={FrameworkTestKeys.settingsToggleIcon}
        />
        <View style={styles.textContainerStyle} testID={FrameworkTestKeys.settingsToggleTitleView}>
          <VFText
            type="primary"
            i18nKey={title}
            style={styles.titleStyle}
            testKey={FrameworkTestKeys.settingsToggleTitleText}
          />
        </View>

        <Toggle
          initialValue={isSelected}
          selected={isSelected}
          onChange={onChange}
          testID={FrameworkTestKeys.settingsToggle}
        />
      </View>

      <VFText
        type="primary"
        i18nKey={description}
        style={styles.descriptionStyle}
        testKey={FrameworkTestKeys.settingsToggleDescriptionText}
      />
    </View>
  );
}

SettingsToggle.defaultProps = {
  theme: LightThemeColors,
  isSelected: false,
};

SettingsToggle.propTypes = {
  theme: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  images: PropTypes.object,
};

export default withTheme(SettingsToggle);
